import { mutatorAction } from 'satcheljs';
import { getStore } from 'owa-mail-folder-forest-store';

/**
 * Preserves the folder to restore when search exits and optionally deselects it while search is
 * shown. The caller must provide the table state captured before navigation selected the search
 * table.
 */
const prepareFolderForestForSearchMutator: (
    wasSearchTableShownBeforeLoad: boolean | undefined,
    shouldDeselectNode: boolean
) => void = mutatorAction(
    'prepareFolderForestForSearch',
    (wasSearchTableShownBeforeLoad: boolean | undefined, shouldDeselectNode: boolean): void => {
        const store = getStore();
        const selectedNode = store.selectedNode;

        if (!selectedNode.id && store.previousNode && !wasSearchTableShownBeforeLoad) {
            store.previousNode = undefined;
        } else if (selectedNode.id && !store.previousNode) {
            store.previousNode = { ...selectedNode };
        }

        if (shouldDeselectNode) {
            selectedNode.id = '';
        }
    }
);

export default function prepareFolderForestForSearch(
    wasSearchTableShownBeforeLoad: boolean | undefined,
    shouldDeselectNode: boolean
): void {
    prepareFolderForestForSearchMutator(wasSearchTableShownBeforeLoad, shouldDeselectNode);
}
